<template>
    <div>
        <h4 class="text-primary text-uppercase font-weight-bold mb-1" v-html="itemP.name" v-if="! _.isEmpty(itemP.options)"></h4>
        <p class="mb-4" v-if="! _.isEmpty(itemP.options) && itemP.adds.desc && itemP.adds.price" v-html="itemP.adds.desc + ': ' + $priceFormat(itemP.adds.price)"></p>

        <div class="table-responsive" v-if="! _.isEmpty(itemP.options)">
            <table class="table table-striped table-hover mb-0">
                <thead>
                    <tr>
                        <th scope="col" class="text-uppercase">Tečaj</th>
                        <th scope="col" class="text-uppercase text-center">Broj sati tjedno</th>
                        <th scope="col" class="text-uppercase text-center" v-for="n in weeks" :key="n" v-html="getWeekString(n)"></th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(item, key) in itemP.options" :key="key">
                        <td v-html="item.name"></td>
                        <td class="text-center" v-html="item.hours + ' nastavnih sati'"></td>
                        <td class="text-center" v-for="(price, index) in item.weeks_display" :key="index">
                            <button type="button" class="btn btn-outline-dark btn-sm" :class="btnActiveClass('P', item.id, index)" v-html="$priceFormat(price)" @click="selectPrice(item.id, price, index)"></button>
                        </td>
                        <td class="text-center" v-for="n in (weeks.length - Object.keys(item.weeks_display).length)" :key="n"></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="card my-5" v-if="data.selectedWeek && data.selectedPricing">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 col-lg-4">
                        <inline-datepicker v-model="data.startsAt" :week-start="1" :disabled-dates="data.excludedDates" :disabled-days="[0,2,3,4,5,6]"></inline-datepicker>
                    </div>

                    <div class="col-md-6">
                        <div class="d-flex flex-column h-100" v-if="data.startsAt">
                            <h6 class="font-weight-bold mb-3">Odabrali ste:</h6>
                            <ul class="list-unstyled" v-if="! _.isEmpty(selectedData.pricing)">
                                <li>
                                    <strong>Tečaj:</strong>
                                    <span v-html="selectedData.pricing.desc"></span>
                                </li>
                                <li>
                                    <strong>Stupanj znanja:</strong>
                                    <span class="text-lowercase" v-html="selectedData.pricing.level"></span>
                                </li>
                                <li>
                                    <strong>Za uzraste:</strong>
                                    <span v-html="selectedData.pricing.age"></span>
                                </li>
                            </ul>
                            <ul class="list-unstyled" v-if="! _.isEmpty(selectedData.accommodation)">
                                <li>
                                    <strong>Smještaj:</strong>
                                    <span v-html="selectedData.accommodation.desc"></span>
                                </li>
                                <li>
                                    <strong>Tip sobe:</strong>
                                    <span v-html="selectedData.accommodation.type"></span>
                                </li>
                                <li>
                                    <strong>Usluga:</strong>
                                    <span v-html="selectedData.accommodation.service"></span>
                                </li>
                                <li>
                                    <strong>Trajanje:</strong>
                                    <span class="text-lowercase" v-html="selectedData.accommodation.duration"></span>
                                </li>
                            </ul>

                            <h6 class="font-weight-bold mb-0 mt-auto">Početak tečaja:<span class="badge badge-success py-1 px-2 ml-1" style="font-size: 100%;" v-html="$dateFormat(data.startsAt)"></span></h6>
                            <h6 class="font-weight-bold mt-2 mb-0" v-if="accommodationStartsAt">Početak smještaja:<span class="badge badge-dark py-1 px-2 ml-1" style="font-size: 100%;" v-html="accommodationStartsAt"></span></h6>
                        </div>
                    </div>

                    <div class="col-md-12 col-lg-2 d-flex align-items-end justify-content-lg-end">
                        <button type="button" class="btn btn-primary" :disabled="! isValidated" v-html="btnValue" @click="submit($event)"></button>
                    </div>
                </div>
            </div>
        </div>

        <h4 class="text-primary text-uppercase font-weight-bold mt-5 mb-1" v-html="itemA.name" v-if="! _.isEmpty(itemA.options)"></h4>
        <p class="mb-4" v-if="! _.isEmpty(itemA.options) && itemA.adds.desc && itemA.adds.price" v-html="itemA.adds.desc + ': ' + $priceFormat(itemA.adds.price)"></p>

        <div class="table-responsive mb-3" v-if="! _.isEmpty(itemA.options)">
            <table class="table table-striped table-hover mb-0">
                <thead>
                    <tr>
                        <th scope="col" class="text-uppercase">Smještaj</th>
                        <th scope="col" class="text-uppercase">Tip sobe</th>
                        <th scope="col" class="text-uppercase">Usluga</th>
                        <th scope="col" class="text-uppercase text-center" v-for="n in weeks" :key="`week-${n}`" v-html="getWeekString(n)"></th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(item, key) in itemA.options" :key="key">
                        <td v-html="item.name"></td>
                        <td v-html="item.type"></td>
                        <td v-html="item.service"></td>
                        <td class="text-center" v-for="(price, index) in item.weeks_display" :key="index">
                            <template v-if="price === 0">
                                <span>-</span>
                            </template>
                            <button v-else type="button" class="btn btn-outline-dark btn-sm" :class="btnActiveClass('A', item.id, index)" v-html="$priceFormat(price)" @click="selectAccommodation(item.id, price, index)"></button>
                        </td>
                        <td class="text-center" v-for="n in (weeks.length - Object.keys(item.weeks_display).length)" :key="n"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import InlineDatepicker from './InlineDatepicker.vue'

export default {
    components: {
        InlineDatepicker
    },

    props: {
        item: {
            type: Object,
            required: true
        },
        itemP: {
            default: function () {
                return {}
            }
        },
        itemA: {
            default: function () {
                return {}
            }
        },
        weeks: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            data: {},
            cart: {}
        }
    },

    computed: {
        previewPrice: function () {
            let total = 0

            // Calculate price of additional required payments
            if (! _.isEmpty(this.cart.adds.price)) {
                total += parseInt(this.cart.adds.price.price)
            }

            if (! _.isEmpty(this.cart.adds.accommodation)) {
                total += parseInt(this.cart.adds.accommodation.price)
            }

            // Calculate price of selected options
            _.forEach(this.cart.selected, function (item) {
                total += parseInt(item.price)
            })

            return total
        },

        selectedData: function () {
            if (this.data.selectedWeek && this.data.selectedPricing) {
                // Get pricing and accommodation based on selected options
                let pricing = this.itemP.options[this.data.selectedPricing]
                let accommodation = null
                if (! _.isEmpty(this.itemA)) {
                    accommodation = this.itemA.options[this.data.selectedAccommodation]
                }
                let week = this.getWeekString(this.data.selectedWeek)
                let pricingData = {}
                let accommodationData = {}

                if (pricing) {
                    // Get formatted price
                    let pricingPrice = this.$priceFormat(pricing.weeks_display[this.data.selectedWeek])

                    // Prepare data for ouput to show user's selected options
                    pricingData = {
                        desc: pricing.name + ' - ' + week + ' - ' + pricingPrice,
                        level: pricing.levels_string,
                        age: pricing.age_min + '+'
                    }
                }

                if (accommodation) {
                    // Get formatted price
                    let accommodationPrice = this.$priceFormat(accommodation.weeks_display[this.data.selectedWeek])

                    // Prepare data for ouput to show user's selected options
                    accommodationData = {
                        desc: accommodation.name + ' - ' + week + ' - ' + accommodationPrice,
                        type: accommodation.type,
                        service: accommodation.service,
                        duration_range: accommodation.duration_range,
                        duration: accommodation.duration_string
                    }
                }

                return {
                    pricing: pricingData,
                    accommodation: accommodationData
                }
            }

            return {}
        },

        accommodationStartsAt: function () {
            let accommodation = this.selectedData.accommodation

            if (! _.isEmpty(accommodation) && this.data.startsAt) {
                //
            }
        },

        isValidated: function () {
            if (this.data.startsAt && this.selectedData.pricing && this.previewPrice > 0) {
                return true
            }

            return false
        },

        btnValue: function () {
            if (this.isValidated) {
                return 'Pošalji upit: ' + this.$priceFormat(this.previewPrice)
            } else {
                return 'Za slanje upita odaberite datum'
            }
        }
    },

    beforeMount() {
        Vue.set(this.data, 'slug', this.item.slug)
        Vue.set(this.data, 'type', 'course-ind')
        Vue.set(this.data, 'selectedWeek', 0)
        Vue.set(this.data, 'selectedPricing', null)
        Vue.set(this.data, 'selectedAccommodation', null)
        Vue.set(this.data, 'startsAt', null)
        Vue.set(this.data, 'excludedDates', [])

        Vue.set(this.cart, 'adds', {
            price: [],
            accommodation: []
        })
        Vue.set(this.cart, 'selected', {
            P: { name: '', price: 0 },
            A: { name: '', price: 0 }
        })
    },

    watch: {
        "data.selectedPricing": function (newVal, oldVal) {
            if (!_.isNull(newVal) && !_.isNull(oldVal) && newVal != oldVal) {
                this.data.startsAt = null
            }
        }
    },

    methods: {
        getWeekString(n) {
            let s = n + 'tj.';

            if (n == 1) s = '1 tjedan';
            if (n >= 2 && n <= 4) s = n + ' tjedna';
            if (n >= 5 && n <= 6) s = n + ' tjedana';

            return s;
        },

        checkSelectedWeek(index, type) {
            let i = parseInt(index)

            if (this.data.selectedWeek > 0) {
                if (i === this.data.selectedWeek) {
                    return true
                } else {
                    if (type == 'P') {
                        if (this.data.selectedAccommodation === null) {
                            this.data.selectedWeek = i
                            return true
                        }
                    }

                    if (type == 'A') {
                        if (this.data.selectedPricing === null) {
                            this.data.selectedWeek = i
                            return true
                        }
                    }

                    return false
                }
            } else {
                this.data.selectedWeek = i
                return true
            }
        },

        resetSelectedWeek() {
            if (this.data.selectedPricing === null && this.data.selectedAccommodation === null) {
                this.data.selectedWeek = 0
            }
        },

        selectPrice(id, amount, weekIndex) {
            if (this.data.selectedPricing == id && this.data.selectedWeek == weekIndex) {
                this.data.selectedPricing = null
                this.cart.selected.P.price = 0
                this.cart.adds.price = []
                this.resetSelectedWeek()
                this._setExcludedDates()
            } else if (this.checkSelectedWeek(weekIndex, 'P')) {
                this.data.selectedPricing = id
                this.cart.selected.P.price = amount
                this.cart.adds.price = {
                    name: this.itemP.adds.desc,
                    price: this.itemP.adds.price
                }

                this._setExcludedDates()
            } else {
                this.errResponse('week')
            }
        },

        selectAccommodation(id, amount, weekIndex) {
            if (this.data.selectedAccommodation == id && this.data.selectedWeek == weekIndex) {
                this.data.selectedAccommodation = null
                this.cart.selected.A.price = 0
                this.cart.adds.accommodation = []
                this.resetSelectedWeek()
                this._setExcludedDates()
            } else if (this.checkSelectedWeek(weekIndex, 'A')) {
                this.data.selectedAccommodation = id
                this.cart.selected.A.price = amount
                this.cart.adds.accommodation = {
                    name: this.itemA.adds.desc,
                    price: this.itemA.adds.price
                }

                this._setExcludedDates()
            } else {
                this.errResponse('week')
            }
        },

        _setExcludedDates() {
            let pricing = this.itemP.options[this.data.selectedPricing],
                accommodation = this.itemA.options[this.data.selectedAccommodation],
                excludedDates = [],
                excludedDatesPricing = [],
                excludedDatesAccommodation = []

            if (pricing && pricing.date_excluded_from && pricing.date_excluded_to) {
                excludedDatesPricing = this.$daysArray(pricing.date_excluded_from, pricing.date_excluded_to)
            }

            if (accommodation && accommodation.date_excluded_from && accommodation.date_excluded_to) {
                excludedDatesAccommodation = this.$daysArray(accommodation.date_excluded_from, accommodation.date_excluded_to)
            }

            this.data.excludedDates = excludedDates.concat(excludedDatesPricing, excludedDatesAccommodation)
        },

        btnActiveClass(type, id, weekIndex) {
            if (type === 'P') {
                if (id == this.data.selectedPricing && weekIndex == this.data.selectedWeek) {
                    return 'btn-active'
                }
            }

            if (type === 'A') {
                if (id == this.data.selectedAccommodation && weekIndex == this.data.selectedWeek) {
                    return 'btn-active'
                }
            }
        },

        errResponse(type) {
            if (type == 'week') {
                alert('Odabrani broj tjedana mora odgovarati za odabranu cijenu i smještaj.')
            }
        },

        submit(e) {
            let btn = e.target

            btn.disabled = true

            axios.post('/naplata', this.data)
                .then(function (response) {
                    if (response.data.status == 'success') {
                        window.location.href = '/naplata'
                    } else {
                        btn.disabled = false
                    }
                })
                .catch(function (error) {
                    btn.disabled = false
                })
        }
    }
}
</script>

<style>
.btn-active,
.btn-active:active,
.btn-active:hover {
    background-color: #212529;
    color: #fff;
}
</style>
